import React from 'react';

import { useTranslation } from 'react-i18next';

import { ArtifactsNavigation, CountHeading } from '@pkg/components';
import { EffectSlideIn } from '@pkg/components/Artifacts/EffectSlideIn/EffectSlideIn';
import { useAppSelector } from '@pkg/hooks';

import { usersOwnedArtifactIds } from '@app/store/selectors/artifacts/artifacts-metadata';

import './ArtifactsSidebar.scss';

export function ArtifactsSidebar() {
    const { t } = useTranslation(['artifacts']);
    const totalIds = useAppSelector(usersOwnedArtifactIds);

    return (
        <aside className="yat-artifacts__sidebar">
            <h1 className="yat-artifacts__sidebar__title">
                <EffectSlideIn>{t('artifacts')}</EffectSlideIn>
            </h1>
            <div className="yat-artifacts__sidebar__owned">
                <CountHeading count={totalIds?.length} delay={250}>
                    {t('owned')}
                </CountHeading>
            </div>
            <hr className="yat-artifacts__sidebar__separator" />
            <ArtifactsNavigation />
        </aside>
    );
}
